<template>
  <el-col :span="24" :style="{height: height}">
    <div :class="className" :style="{height:chartHeight,width:chartWidth}" @click="onClick" />
  </el-col>
</template>

<script>
  import echarts from 'echarts'
  require('echarts/theme/macarons') // echarts theme
  import {
    debounce
  } from '../utils/helper.js'
  import lodash from 'lodash'
  export default {
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      width: {
        type: Number,
        default: 24
      },
      height: {
        type: String,
        default: '100%'
      },
      autoResize: {
        type: Boolean,
        default: true
      },
       show:{
              type:Boolean,
              default:true
            },
      // 图标配置
      chartConfig: {
        type: Object,
        default: function() {
          return {}
        }
      }
    },
    data() {
      return {
        chart: null,
        sidebarElm: null,
        chartConfigModel: {},
        chartWidth: '100%',
        chartHeight: '100%',
        defaultConfig: {
          title: {
            text: null,
            left: 'center',
            show: true
          },
          xAxis: {
            data: [],
            boundaryGap: false,
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
            },
            //是否去掉网格线
            splitLine: {
              show: false
            },
            //是否显示网格区域
            splitArea: {
              show: false
            }
          },
          yAxis: {
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            splitArea: {
              show: false
            } //保留网格区域
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            top:'3%',
            containLabel: true
          },
          dataZoom: null,
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            padding: [5, 10]
          },

          legend: {
            data: [],
            left: 'center',
            top: 'bottom',
            padding: 5,
            show: false
          },
          series: []
        }

      }
    },
    computed: {
      widthHeight() {
        return {
          width: this.width,
          height: this.height
        }
      }
    },
    watch: {
      // 防止表格预置数据不成功，涉及生命周期问题
      chartConfig: {
        handler(newValue, oldValue) {
          this.chartConfigModel = lodash.cloneDeep(newValue)
          let _config = lodash.cloneDeep(this.defaultConfig)
          lodash.merge(_config, this.chartConfigModel)
          this.chartConfigModel = _config
          this.setOptions(true)
        },
        deep: true
      },
      widthHeight: {
        handler(newValue, oldValue) {
          this.__resizeHandler()
        },
        deep: true
      },
        show:{
              handler(newValue,oldValue){
                this.__resizeHandler()
              },
              deep:true
            }
    },
    created() {

    },
    mounted() {

      this.chartConfigModel = lodash.cloneDeep(this.chartConfig)
      let _config = lodash.cloneDeep(this.defaultConfig)
      lodash.merge(_config, this.chartConfigModel)
      this.chartConfigModel = _config
      this.initChart()
      this.setOptions(false)
      if (this.autoResize) {
        this.__resizeHandler = debounce(() => {
          if (this.chart) {
            this.chart.resize()
          }
        }, 100)
        window.addEventListener('resize', this.__resizeHandler)
      }

      // 监听侧边栏的变化
      this.sidebarElm = document.getElementsByClassName('sidebar-container')[0]
      this.sidebarElm && this.sidebarElm.addEventListener('transitionend', this.sidebarResizeHandler)

    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      if (this.autoResize) {
        window.removeEventListener('resize', this.__resizeHandler)
      }

      this.sidebarElm && this.sidebarElm.removeEventListener('transitionend', this.sidebarResizeHandler)

      this.chart.dispose()
      this.chart = null
    },
    methods: {
      sidebarResizeHandler(e) {
        if (e.propertyName === 'width') {
          this.__resizeHandler()
        }
      },
      setOptions(notMerge) {
        this.chart.setOption(this.chartConfigModel, notMerge)
        this.chart.resize()
      },
      initChart() {
        this.chart = echarts.init(this.$el, 'macarons')
        this.setOptions(false)
      },
      onClick() {}

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PointChart.vue